import $ from "jquery";
import Notices from "./Notices";
import AjaxBlocking from "./AjaxBlocking";

export default class MyAccountReturns {
    constructor() {
        this.reasonSelects = document.querySelector(".jsReturnProductsSelect");
        this.makeRefundBtns = document.querySelector(".jsMakeRefund");
        this.addReturnFormFile = document.querySelector(".jsAddReturnForm");
        this.returnCheckboxes = [
            ...document.querySelectorAll(".jsReturnsCheckbox"),
        ];
        this.quantityInputs = [
            ...document.querySelectorAll(".jsReturnsQuantity"),
        ];
        this.returnErrorsContainer = document.querySelector(
            ".jsReturnErrorsContainer"
        );

        this.returnProductsContent = document.querySelector(
            ".jsReturnProductsContent"
        );

        this.returnHeading = document.querySelector(".jsReturnHeading");

        this.productsToReturn = [];
        this.refundFile = {};

        this.returnErrors = {};
        this.submitAllowed = false;

        if (
            this.reasonSelects &&
            this.makeRefundBtns &&
            this.addReturnFormFile &&
            this.returnErrorsContainer &&
            this.returnCheckboxes.length &&
            this.quantityInputs.length
        ) {
            this.events();
        }
    }

    events() {
        window.addEventListener("DOMContentLoaded", () => {
            this.initializeSelectField();
        });

        this.makeRefundBtns.addEventListener("click", (e) => {
            this.makeRefund(e, this.refundFile);
        });

        this.addReturnFormFile.addEventListener("change", (e) => {
            if (e.currentTarget.files.length > 0) {
                this.makeFileString(e.currentTarget);
            }
        });

        this.quantityInputs.forEach((input) =>
            input.addEventListener("change", (e) => {
                this.validateQuantityInput(e.currentTarget);
            })
        );
    }

    initializeSelectField() {
        const select = this.reasonSelects;

        $(select).select2({
            placeholder: select.dataset.placeholderText,
            minimumResultsForSearch: -1,
        });
    }

    filterCheckedCheckboxes() {
        return this.returnCheckboxes.filter((checkbox) => checkbox.checked);
    }

    validateQuantityInput(input) {
        let quantity;

        const currentValue = parseInt(input.value, 10);
        const minVal = parseInt(input.min, 10);
        const maxVal = parseInt(input.max, 10);

        if (currentValue < minVal) {
            quantity = minVal;
        } else if (currentValue > maxVal) {
            quantity = maxVal;
        } else {
            quantity = currentValue;
        }

        input.value = quantity;
    }

    getSelectedItems(checkboxes) {
        const selectedItems = [];

        if (checkboxes.length) {
            checkboxes.forEach((checkbox) =>
                selectedItems.push(checkbox.closest(".jsReturnsItem"))
            );
        }

        return selectedItems;
    }

    getItemsWithQuantity(items) {
        const products = [];

        if (items.length) {
            items.forEach((item) => {
                const input = item.querySelector(".jsReturnsQuantity");
                this.validateQuantityInput(input);

                const quantity = parseInt(input.value, 10);

                if (quantity > 0) {
                    const product = {
                        product_id: parseInt(item.dataset.productId, 10),
                        quantity: quantity,
                    };
                    products.push(product);
                }
            });
        }

        return products;
    }

    getProducts() {
        const selectedChekboxes = this.filterCheckedCheckboxes();
        const selectedItems = this.getSelectedItems(selectedChekboxes);
        const selectedProducts = this.getItemsWithQuantity(selectedItems);

        return selectedProducts;
    }

    getReason() {
        const select = this.reasonSelects;
        const info = $(select).select2("data")[0].text;

        return info;
    }

    makeFileString(fileInput) {
        const file = fileInput.files[0];
        const self = this;

        const reader = new FileReader();
        reader.addEventListener(
            "load",
            function (e) {
                self.refundFile = {
                    fileString: reader.result,
                    fileExt: file.name.split(".").pop().toLowerCase(),
                };
            },
            false
        );

        reader.readAsDataURL(file);
    }

    showReturnErrors(errors, container) {
        let errorsHTML = "";

        for (const error in errors) {
            errorsHTML += `<p>${errors[error]}</p>`;
        }

        container.innerHTML = errorsHTML;
        container.classList.add("is-active");
    }

    handleSubmitErrors(products, reason, file) {
        if (!reason.length) {
            this.returnErrors.errorSelect =
                this.returnErrorsContainer.dataset.errorSelect;
        } else {
            delete this.returnErrors.errorSelect;
        }

        if (!products.length) {
            this.returnErrors.errorProducts =
                this.returnErrorsContainer.dataset.errorProducts;
        } else {
            delete this.returnErrors.errorProducts;
        }

        if (!Object.keys(file).length) {
            this.returnErrors.errorForm =
                this.returnErrorsContainer.dataset.errorForm;
        } else {
            delete this.returnErrors.errorForm;
        }

        if (Object.keys(this.returnErrors).length) {
            this.submitAllowed = false;
            this.showReturnErrors(
                this.returnErrors,
                this.returnErrorsContainer
            );
        } else {
            this.returnErrorsContainer.classList.remove("is-active");
            this.returnErrorsContainer.innerHTML = "";
            this.submitAllowed = true;
        }
    }

    handleAjaxSuccess() {
        const successMessage = this.returnProductsContent.dataset.returnSuccess;
        const btnUrl = this.returnProductsContent.dataset.buttonUrl;
        const btnText = this.returnProductsContent.dataset.buttonText;

        const successHTML = `
            <p class="my-account__return-products__success-msg">${successMessage}</p>
            <a class="btn btn--black return-products__btn-success" href="${btnUrl}">${btnText}</a>
        `;

        this.returnProductsContent.innerHTML = successHTML;
        this.returnHeading.innerHTML = "";
    }

    handleAjaxError() {
        this.returnErrors.returnError =
            this.returnErrorsContainer.dataset.returnError;
        this.showReturnErrors(this.returnErrors, this.returnErrorsContainer);

        setTimeout(() => {
            delete this.returnErrors.returnError;
            this.returnErrorsContainer.innerHTML = "";
            this.returnErrorsContainer.classList.remove("is-active");
        }, 4000);
    }

    makeRefund(e, file) {
        const self = this;
        const products = this.getProducts();
        const reason = this.getReason();

        this.handleSubmitErrors(products, reason, file);

        if (!this.submitAllowed) return;

        let data = {
            action: "makeRefund",
            orderId: parseInt(e.currentTarget.dataset.orderId, 10),
            products: products,
            reason: reason,
            file: file,
        };

        console.log(data);

        $.ajax({
            // eslint-disable-next-line no-undef
            url: ajax.ajaxurl,
            type: "POST",
            data: data,
            beforeSend: function () {
                self.makeRefundBtns.disabled = true;
                self.makeRefundBtns.classList.add("is-sending");
                self.blockForAjax();
            },
            success: function (response) {
                if (response) {
                    if (response === "true") {
                        console.log("Utworzono zwrot");
                        self.makeRefundBtns.classList.remove("is-sending");
                        self.makeRefundBtns.classList.add("is-success");
                        self.handleAjaxSuccess();
                        data = {};
                        // eslint-disable-next-line no-unused-vars
                        const refundNotices = new Notices(true);
                    } else {
                        console.log("Nie utworzono zwrotu");
                        self.makeRefundBtns.classList.remove("is-sending");
                        self.makeRefundBtns.disabled = false;
                        self.handleAjaxError();
                    }
                    self.unblockForAjax();
                }
            },
            error: function (request) {
                console.log(request.responseText);
                self.makeRefundBtns.classList.remove("is-sending");
                self.makeRefundBtns.disabled = false;
                self.unblockForAjax();
            },
        });
    }

    blockForAjax() {
        if (!this.returnProductsContent) return;

        const section = this.returnProductsContent.closest(
            ".woocommerce-MyAccount-content"
        );

        console.log(section);

        if (!section) return;

        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(section);
    }

    unblockForAjax() {
        if (!this.returnProductsContent) return;

        const section = this.returnProductsContent.closest(
            ".woocommerce-MyAccount-content"
        );

        console.log(section);

        if (!section) return;

        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(section);
    }
}
